import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { Button, Form } from "antd";
import { useEffect } from "react";

const EquipmentsModal = ({
  show,
  handleCancel,
  formSubmit,
  selectStaffProperty,
  bookingsFieldsEnabled = true,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isNonEmptyVariable(selectStaffProperty)) {
      form.setFieldsValue(selectStaffProperty);
    } else {
      form.resetFields();
    }
  }, [selectStaffProperty]);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const data = {
        ...values,
        dateAssigned: isNonEmptyVariable(values?.dateAssigned)
          ? values?.dateAssigned?.format("MM/DD/YYYY")
          : null,
        dateReturned: isNonEmptyVariable(values?.dateReturned)
          ? values?.dateReturned?.format("MM/DD/YYYY")
          : null,
      };
      formSubmit(data);
      form.resetFields();
    });
  };

  function handleFormCancel() {
    handleCancel();
    form.resetFields();
  }
  return (
    <>
      <Modal
        show={show}
        handleCancel={handleFormCancel}
        onHide={handleFormCancel}
        handleSubmit={handleSubmit}
        designPattern="ant"
        width="75%"
        header={`${
          selectStaffProperty ? "VIEW" : "ADD"
        } Items Assigned To Staff Member`}
        footerActions={[
          <Button
            key="SUBMIT"
            onClick={handleFormCancel}
            disabled={!bookingsFieldsEnabled}
          >
            Close
          </Button>,
          <Button
            key="SUBMIT"
            onClick={handleSubmit}
            disabled={!bookingsFieldsEnabled}
          >
            Submit
          </Button>,
        ]}
      >
        <Form form={form} disabled={!bookingsFieldsEnabled}>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol span={12}>
              <FormItem label="Category" name="categoryID">
                <Select
                  id="propertyCategory"
                  options={getOptionsFromRefList(
                    "StaffProperty_Category",
                    false,
                    false,
                    true
                  )}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={12}>
              <FormItem label="Product" name="productID">
                <Select
                  id="product"
                  options={getOptionsFromRefList(
                    "StaffProperty_Product",
                    false,
                    false,
                    true
                  )}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol span={8}>
              <FormItem name={["propertyWithSerialNumberRequest",0,"manufacturer"]} label="Manufacturer">
                <TextField id="manufacturer" />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={8}>
              <FormItem name={["propertyWithSerialNumberRequest",0,"model"]} label="Model">
                <TextField id="model" />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={8}>
              <FormItem name="colorID" label="Color">
                <Select
                  id="color"
                  options={getOptionsFromRefList(
                    "PropertyColor",
                    false,
                    false,
                    true
                  )}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol span={12}>
              <FormItem name={["propertyWithSerialNumberRequest",0,"serialNumber"]} label="Serial Number">
                <TextField id="serialNumber" />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem name="cost" label="Cost">
                <TextField id="cost" />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol span={24}>
              <FormItem name="description" label="Description">
                <TextField id="description" inputType="textarea" />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol span={8}>
              <FormItem label="Assigned By" name="assignedByStaffID">
                <Select
                  id="assignedBy"
                  options={getOptionsFromRefList("", true, false, true)}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem label="Date Assigned" name="dateAssigned">
                <CommonDatePicker
                  id="dateAssigned"
                  format="MM/DD/YYYY"
                  showTime={false}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={4}>
              <FormItem label="Quantity" name="quantity">
                <TextField id="quantity" type="number" />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem label="Status" name="statusID">
                <Select
                  id="status"
                  options={getOptionsFromRefList(
                    "StaffProperty_Status",
                    false,
                    false,
                    true
                  )}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol span={12}>
              <FormItem label="Returned To" name="returnedToStaffID">
                <Select
                  id="returnedTo"
                  options={getOptionsFromRefList("", true, false, true)}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem label="Date Returned" name="dateReturned">
                <CommonDatePicker
                  id="dateReturned"
                  format="MM/DD/YYYY"
                  showTime={false}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
      </Modal>
    </>
  );
};

export default EquipmentsModal;
